import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide4 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={3}
      total={total}
      label="End-to-End Flow"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(130deg,#020403,#070806),radial-gradient(700px 500px at 70% 32%,rgba(216,182,46,.2),transparent 70%)"
      }}
    >

      <h2>{t.title}</h2>

      <div className="flow">
        <div className="step"><b>01</b><span>{t.flow1}</span></div>
        <div className="step"><b>02</b><span>{t.flow2}</span></div>
        <div className="step"><b>03</b><span>{t.flow3}</span></div>
        <div className="step"><b>04</b><span>{t.flow4}</span></div>
        <div className="step"><b>05</b><span>{t.flow5}</span></div>
        <div className="step"><b>06</b><span>{t.flow6}</span></div>
      </div>

      <table className="matrix">
        <thead>
          <tr>
            <th>{t.tableH1}</th>
            <th>{t.tableH2}</th>
            <th>{t.tableH3}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t.r1C1}</td>
            <td>{t.r1C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r2C1}</td>
            <td>{t.r2C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
          <tr>
            <td>{t.r3C1}</td>
            <td>{t.r3C2}</td>
            <td><span className="coverage">{t.covered}</span></td>
          </tr>
        </tbody>
      </table>
    </SlideShell>
  );
};


